import { createNavigationContainerRef } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';

import { RootStackParamList } from '../../app/navigator';

export const navigationRef = createNavigationContainerRef<RootStackParamList>();

export function navigateToJoinTournaments(tournamentId: string, entryLevel?: number) {
	if (!navigationRef.isReady()) return;

	const currentRoute = navigationRef.getCurrentRoute();
	const currentTableId = (currentRoute?.params as { tableId?: string | number } | undefined)
		?.tableId;
	if (currentRoute?.name === 'Game' && String(currentTableId ?? '') === String(tournamentId)) {
		return;
	}

	navigationRef.navigate('JoinTournaments', {
		tournamentId,
		entryLevel,
	});
}

// The footer / dock destinations that behave like tabs rather than pages stacked on each other.
const TAB_ROUTES = new Set<keyof RootStackParamList>(['Ranking', 'Bonuses']);

type TabNavigation = Pick<
	NativeStackNavigationProp<RootStackParamList>,
	'getState' | 'navigate' | 'popTo'
>;

/**
 * Opens a footer destination the way a tab bar would. React Navigation 7's `navigate` no longer
 * goes back to a screen already in the stack, so Home -> Rankings -> Home -> Bonuses -> Home kept
 * stacking full copies of each screen (header, footer, sockets and all) and every Home tap built a
 * new one. Instead: go back to the destination when it is already in the stack, swap it in for the
 * current screen when that is another tab, and only push from anywhere else.
 */
export function navigateToTab(navigation: TabNavigation, name: 'Main' | 'Ranking' | 'Bonuses') {
	const state = navigation.getState();
	const currentName = state.routes[state.index]?.name as keyof RootStackParamList | undefined;
	const inStack = state.routes.some(route => route.name === name);

	if (name === 'Main' || inStack || (currentName && TAB_ROUTES.has(currentName))) {
		navigation.popTo(name);
		return;
	}

	navigation.navigate(name);
}
